import { DotNet } from '@microsoft/dotnet-js-interop';
import { $isLinkNode, TOGGLE_LINK_COMMAND, toggleLink } from "@lexical/link";
import {
    LexicalEditor,
    $getSelection,
    RangeSelection,
    $isRangeSelection,
    COMMAND_PRIORITY_LOW
} from "lexical";

function Create(editor: LexicalEditor, dotNetObject?: DotNet.DotNetObject) {
    console.log('LexicalEditorLinkPlugin Create');
    registerCommands(editor);
    registerEvents(editor, dotNetObject);
}

function Link(editor: LexicalEditor, url: string) {
    if (editor != null) {
        editor.dispatchCommand(TOGGLE_LINK_COMMAND, url);
    }
}

// Internal helpers
function getSelectedNode(selection: RangeSelection) {
    const anchorNode = selection.anchor.getNode();
    const focusNode = selection.focus.getNode();
    if (anchorNode === focusNode) {
        return anchorNode;
    }
}

function registerCommands(editor: LexicalEditor) {
    editor.registerCommand(
        TOGGLE_LINK_COMMAND,
        (payload: any) => {
            const selection = $getSelection();
            if (!$isRangeSelection(selection)) {
                return false;
            }
            const node = getSelectedNode(selection as RangeSelection);
            if (node !== undefined) {
                const parent = node.getParent();
                if ($isLinkNode(parent) || $isLinkNode(node)) {
                    toggleLink(null);
                } else {
                    toggleLink(payload);
                }
            }
            return true;
        },
        COMMAND_PRIORITY_LOW
    );
}

function registerEvents(editor: LexicalEditor, dotNetObject?: DotNet.DotNetObject) {
    const rootElement = editor.getRootElement();
    if (rootElement) {
        rootElement.addEventListener('click', async (event: MouseEvent) => {
            // Prevent default browser behavior when needed
            event.preventDefault();

            editor.update(() => {
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) {
                    return;
                }
                const node = getSelectedNode(selection as RangeSelection);
                if (node === undefined) return;

                const parent = node.getParent();
                // Example: if we need to notify .NET when clicking an existing link
                // if ($isLinkNode(parent) && dotNetObject) {
                //     dotNetObject.invokeMethodAsync('LinkClick' /*, parent.getURL()*/);
                // }
            });
        });
    } else {
        console.error('Root element of the editor is null.');
    }
}

export default {
    Create,
    Link
};

